import VaultBaseController from '../common/vault.base.controller'

class VaultallController extends VaultBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, VaultService, $translate, $stateParams, $scope) {

    super(Auth, $state, User, VaultService, Modal, $translate, $stateParams)

    this.id = 'vault.all'
    this.loading = true
    this.vaultes = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = []
    this.searchText = ''
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(vault) {
    this.$state.go('vault.edit', ({
      id: vault.id
    }))
  }

  delete(vault) {
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${vault.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(vault.id)
          .then((data) => {
            modal.close()
            this.refresh()
          })
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    this.loadData()
  }

  generateSearchObj() {
    return {
      queryText: '%' + this.searchText + '%',
      isQuery: false
    }
  }

  search() {
    this.page = 1;
    this.loadData()
  }

  loadData() {
    const searchObj = this.generateSearchObj()

    this.loading = true;
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total

        this.loading = false
        this.vaultes = data.results
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }
  toggleExpand(vault) {
    vault.expand = !vault.expand;
  }
}

export default VaultallController;


// WEBPACK FOOTER //
// ./client/app/components/vault/all/vault.all.controller.js